import { useMutation } from '@apollo/client/react';
import { StoreSignInDocument } from '@drycut/graphql';
import { type PropsWithChildren, useState } from 'react';

import type { SignInInput } from './types';

import { AuthContext } from './AuthContext';

export function AuthProvider({ children }: PropsWithChildren): React.ReactElement {
  const [mutate, { loading }] = useMutation(StoreSignInDocument);
  const [error, setError] = useState<string>();

  const saveSession = (token: string, slug: string) => {
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('slug', slug);
  };

  const token = sessionStorage.getItem('token');
  const currentSlug = sessionStorage.getItem('slug');

  async function signIn({ slug, password }: SignInInput): Promise<boolean> {
    setError(undefined);

    const result = await mutate({ variables: { input: { slug, password } } });
    const token = result.data?.storeSignIn?.token;
    const store = result.data?.storeSignIn?.store;

    if (token && store) {
      saveSession(token, store.slug);

      return true;
    } else {
      setError(result.data?.storeSignIn?.errors?.[0]?.message || 'An error occurred');
    }

    return false;
  }

  function signOut() {
    sessionStorage.clear();
  }

  const value = { currentSlug, signOut, signIn, loading, token, error };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
